import { http } from './client';
import type { McpConfigPatch, McpConfigView } from './types';

export const mcpApi = {
  async get(botId: string): Promise<McpConfigView> {
    const res = await http.get<McpConfigView>(`/v1/org/bots/${encodeURIComponent(botId)}/mcp`);
    return res.data;
  },
  async update(botId: string, patch: McpConfigPatch): Promise<McpConfigView> {
    const res = await http.put<McpConfigView>(
      `/v1/org/bots/${encodeURIComponent(botId)}/mcp`,
      patch,
    );
    return res.data;
  },
};
